import {createSelector} from 'reselect';
import props from '../../props';

export default createSelector(
    props.modules.module_modals,
    props.modules.module_modals_data,
    (modals, modals_data) => {
        const modal = modals.filter(m => m.visible)[0] || null;

        return {
            modal: modal,
            data: modal ? modals_data[modal.key] : null
        }
    }
)